export const SECTION_TITLES = {
  EVENT_DETAILS: 'Detalhes do evento',
  SITE_DISPLAY: 'Exibição no site'
}

export const BUTTON_LABELS = {
  CREATE: 'Criar cadastro',
  UPDATE: 'Revisar cadastro',
  CANCEL: 'Cancelar',
  BACK: 'Voltar'
}

export const SITE_DISPLAY_DESCRIPTION =
  'Para os clientes que efetuarem o resgate do ingresso, a visualização do evento se mantém até a data de sua realização.'
